import origins from '@/config/origins'
import callbacks from './callbacks'
import remapParams from './remapParams'
import { requestConfig } from '@altenar/transport'
import core from '@altenar/core'

const defaultConfig = {
  timezoneOffset: new Date().getTimezoneOffset(),
  langId: '1',
  skinName: 'default',
  configId: '1',
  culture: 'en',
  countryCode: 'en',
  numFormat: 'en',
  scriptspath: './',
  debug: false,
  instance: 'config',
  version: new Date().getTime(),
  dimensionWidths: [290, 800, 1024, 1342, 1600],
  topSportsMaxTabs: {
    livenow: 3,
    highlights: 3,
    upcoming: 3
  }
}

const config = {
  ...defaultConfig,
  origins,
  callbacks,
  extend: extendConfig
}

export function extendConfig(extParams) {
  const loweredParams = remapParams(extParams)
  for (const defaultPropName of Object.keys(defaultConfig)) {
    const defaultLoweredPropName = defaultPropName.toLowerCase()
    if (loweredParams[defaultLoweredPropName]) {
      config[defaultPropName] = loweredParams[defaultLoweredPropName]
    }
  }
  callbacks.extend(extParams)
}

export function setDefaultRequestParams() {
  requestConfig.defaultRequestParams = {
    timezoneOffset: config.timezoneOffset,
    langId: config.langId,
    skinName: config.skinName,
    configId: config.configId,
    numFormat: config.numFormat,
    culture: config.culture,
    countryCode: config.countryCode,
    deviceType: core.config.isMobile ? 'mobile' : 'desktop'
  }
}
export default config
